import React from 'react';
import { Flex, Text, Box, Container, Button, Grid, GridItem, Link } from '@chakra-ui/react';

import { conferenceServiceItems } from "../DATABASE/serviceConference";
import { editorialItems } from "../DATABASE/serviceEditorial";
import { technicalItems } from "../DATABASE/serviceTechnical";


function ServiceAndMembership() {
    return (
    <>
        <Container maxW="1200px" py={5} centerContent>
            {/* Header Section */}
            <Flex direction="column" align="left">
                <Text fontSize="25px" fontWeight="bold" textAlign="center">
                        Service and Memberships,{" "}
                    <Link href="/">
                        <Text as="span" color="blue.600" fontStyle="italic" fontWeight="bold" textDecoration="underline">
                            Dr. Burak Kantarci 
                        </Text>
                    </Link>
                </Text>
            </Flex>

            {/* Navigation Buttons */}
            {/*
            <Flex justify="center" mt={4} gap={1} wrap="wrap">
                <Button as="a" href="#Editorial" variant="outline" bg="gray.200" boxShadow="md">
                    Editorial Activities
                </Button>
                <Button as="a" href="#Technical" variant="outline" bg="gray.200" boxShadow="md">
                    Technical Committee Officer
                </Button>
                <Button as="a" href="#Conference" variant="outline" bg="gray.200" boxShadow="md">
                    Conference / Workshop / Track Chair
                </Button>
                <Button as="a" href="#Other" variant="outline" bg="gray.200" boxShadow="md">
                    Other Professional Activities
                </Button>
                <Button as="a" href="#Memberships" variant="outline" bg="gray.200" boxShadow="md">
                    Memberships
                </Button>
            </Flex>
            */}

            {/* Navigation Buttons */}
            <Flex justify="center" mt={4} gap={2} wrap="wrap">
                <Button
                    onClick={() => {
                        const target = document.getElementById("Editorial");
                        const offset = 85; // ~3 cm
                        if (target) {
                        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({ top, behavior: 'auto' });
                        }
                    }}
                    variant="outline"
                    bg="gray.200"
                    boxShadow="md"
                    >
                    Editorial Activities
                </Button>
                <Button
                    onClick={() => {
                        const target = document.getElementById("Technical");
                        const offset = 85; // ~3 cm
                        if (target) {
                        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({ top, behavior: 'auto' });
                        }
                    }}
                    variant="outline"
                    bg="gray.200"
                    boxShadow="md"
                    >
                    Technical Committee Officer
                </Button>
                <Button
                    onClick={() => {
                        const target = document.getElementById("Conference");
                        const offset = 85; // ~3 cm
                        if (target) {
                        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({ top, behavior: 'auto' });
                        }
                    }}
                    variant="outline"
                    bg="gray.200"
                    boxShadow="md"
                    >
                    Conference / Workshop / Track Chair
                </Button>
                <Button
                    onClick={() => {
                        const target = document.getElementById("Other");
                        const offset = 85; // ~3 cm
                        if (target) {
                        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({ top, behavior: 'auto' });
                        }
                    }}
                    variant="outline"
                    bg="gray.200"
                    boxShadow="md"
                    >
                    Other Professional Activities
                </Button>
                <Button
                    onClick={() => {
                        const target = document.getElementById("Memberships");
                        const offset = 85; // ~3 cm
                        if (target) {
                        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({ top, behavior: 'auto' });
                        }
                    }}
                    variant="outline"
                    bg="gray.200"
                    boxShadow="md"
                    >
                    Memberships
                </Button>
            </Flex>

            {/* Contents */}
            <Box mt={6} w="100%">
                <Text id="Editorial" fontSize="lg" fontWeight="bold" mb={3}>
                    Editorial Activities <Link href="#" color="blue.500">(back)</Link>
                </Text>

                <Grid templateColumns="1fr 1fr 3fr" gap={4}>
                    {editorialItems.map((item, index) => (
                        <React.Fragment key={index}>
                            <GridItem fontWeight="bold">{item.date}</GridItem>
                            <GridItem fontStyle="italic">{item.title}</GridItem>
                            <GridItem>{item.text}</GridItem>
                        </React.Fragment>
                    ))}
                </Grid>
            </Box>

            <Box mt={6} w="100%">
                <Text id="Technical" fontSize="lg" fontWeight="bold" mb={3}>
                    Technical Committee Officer <Link href="#" color="blue.500">(back)</Link>
                </Text>

                <Grid templateColumns="1fr 1fr 3fr" gap={4}>
                    {technicalItems.map((item, index) => (
                        <React.Fragment key={index}>
                            <GridItem fontWeight="bold">{item.date}</GridItem>
                            <GridItem fontStyle="italic">{item.title}</GridItem>
                            <GridItem>{item.text}</GridItem>
                        </React.Fragment>
                    ))}
                </Grid>
            </Box>


            <Box mt={6} w="100%">
                <Text id="Conference" fontSize="lg" fontWeight="bold" mb={3}>
                    Conference / Workshop / Track Chair <Link href="#" color="blue.500">(back)</Link>
                </Text>

                <Grid templateColumns="1fr 1fr 3fr" gap={4}>
                    {conferenceServiceItems.map((item, index) => (
                        <React.Fragment key={index}>
                            <GridItem fontWeight="bold">{item.date}</GridItem>
                            <GridItem fontStyle="italic">{item.title}</GridItem>
                            <GridItem>{item.text}</GridItem>
                        </React.Fragment>
                    ))}
                </Grid>
            </Box>
            
            <Box mt={6} w="100%">
                <Text id="Other" fontSize="lg" fontWeight="bold" mb={3}>
                    Other Professional Activities <Link href="#" color="blue.500">(back)</Link>
                </Text>

                <Grid templateColumns="1fr 1fr 3fr" gap={4}>
                        <GridItem fontWeight="bold">2021-2022</GridItem>
                        <GridItem fontStyle="italic">Founding Faculty Sponsor</GridItem>
                        <GridItem>Association for Computing Machinery (ACM)-Women in Computing uOttawa Chapter. <Text as="span" textDecoration="underline">  (This chapter was founded by 10 women graduate students, 7 of which were in my research team with the founding chair and vice-chair being my PhD students. This chapter was one of the only two ACM-W chapters in Canada when it was founded.)</Text></GridItem>
                </Grid>
            </Box>

            <Box mt={6} w="100%">
                <Text id="Memberships" fontSize="lg" fontWeight="bold">
                    Memberships <Link href="#" color="blue.500">(back)</Link>
                </Text>

                <Box mt={3}>
                    <Text>IEEE Senior Member (S 05, M 09, SM 12)</Text>
                    <Text>ACM Senior Member (M 15, SM 20)</Text>
                    <Text>Member, Sigma Xi, The Scientific Research Honor Society (ΣΞ)</Text>
                    <Text>IEEE Systems Council Member</Text>
                    <Text>IEEE Sensors Council Member</Text>
                    <Text>IEEE Vehicular Technology Society Member</Text>
                    <Text>IEEE Intelligent Transportation Systems Society Member</Text>
                    <Text>IEEE Communications Society Member</Text>
                    <Text>IEEE Sustainable ICT Community, Member</Text>
                    <Text>Professional Engineers Ontario (PEO)</Text>
                </Box>
            </Box>


        </Container>
        
      
    </>
    );
  }


  export default ServiceAndMembership;